import { render, staticRenderFns } from "./Meetings.vue?vue&type=template&id=2bf1a1ff&scoped=true&"
import script from "./Meetings.vue?vue&type=script&lang=js&"
export * from "./Meetings.vue?vue&type=script&lang=js&"
import style0 from "./Meetings.vue?vue&type=style&index=0&id=2bf1a1ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1a1ff",
  null
  
)

export default component.exports